
import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";
import { Facebook, Instagram, MessageCircle } from "lucide-react";
import { useTranslations } from "@/hooks/useTranslations";

interface ContactCardProps {
  instagramUrl?: string;
  facebookUrl?: string;
}

export const ContactCard = ({ instagramUrl, facebookUrl }: ContactCardProps) => {
  const { t } = useTranslations("publicProfile");
  
  if (!instagramUrl && !facebookUrl) return null;
  
  return (
    <Card className="border-none shadow-lg bg-white/80 dark:bg-gray-800/80 backdrop-blur-sm h-full">
      <CardContent className="p-6">
        <div className="flex items-center gap-2 mb-4">
          <MessageCircle className="h-5 w-5 text-gray-700 dark:text-gray-300" />
          <h2 className="text-xl font-semibold text-gray-900 dark:text-gray-100">{t("contacts")}</h2>
        </div>
        
        <div className="flex flex-wrap gap-4 mt-6">
          {instagramUrl && (
            <Button asChild className="bg-gradient-to-r from-[#8A3AB9] to-[#E95950] hover:opacity-90 shadow-md w-full">
              <a href={instagramUrl} target="_blank" rel="noopener noreferrer" className="flex items-center justify-center">
                <Instagram className="mr-2 h-5 w-5" />
                <span className="font-medium">Instagram</span>
              </a>
            </Button>
          )}
          
          {facebookUrl && (
            <Button asChild className="bg-[#3b5998] hover:bg-[#2d4373] shadow-md w-full">
              <a href={facebookUrl} target="_blank" rel="noopener noreferrer" className="flex items-center justify-center">
                <Facebook className="mr-2 h-5 w-5" />
                <span className="font-medium">Facebook</span>
              </a>
            </Button>
          )}
        </div>
      </CardContent>
    </Card>
  );
};
